import React, { type ReactNode } from 'react'

import { Box, FontWeight, Heading2, Text } from '@gousto-internal/citrus-react'
import { CategoryBrandingContentBlock } from '@library/api-menu-experience'
import { getDefaultImage } from '../../utils'

type CategoryBrandingProps = {
  contentBlock: CategoryBrandingContentBlock
  recipeCount: number
  children: ReactNode
}

export const CategoryBranding = ({
  contentBlock,
  recipeCount,
  children,
}: CategoryBrandingProps) => {
  const backgroundImageUrl = getDefaultImage(contentBlock.backgroundImage.crops)

  return (
    <Box
      data-testid="category-branding"
      width="100%"
      maxWidth="1600px"
      style={{
        margin: '-1rem auto 0',
        backgroundColor: contentBlock.backgroundColor,
        ...(backgroundImageUrl
          ? {
              backgroundImage: `url(${backgroundImageUrl})`,
              backgroundPosition: 'top center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: '100% auto',
            }
          : {}),
      }}
    >
      <Box
        data-testid="category-branding-hero"
        paddingV={[5, 6, 6]}
        paddingBottom={[1, 2, 2]}
        paddingH={6}
        style={{ backgroundColor: 'transparent' }}
      >
        <Box maxWidth={['100%', '100%', '52rem']}>
          <Heading2 style={{ color: contentBlock.textColor }}>{contentBlock.title}</Heading2>
          <Box paddingBottom={3} style={{ marginTop: '0.5rem' }}>
            <Text style={{ color: contentBlock.textColor }}>{contentBlock.description}</Text>
          </Box>
          <Text fontWeight={FontWeight.Bold} size={4} style={{ color: contentBlock.textColor }}>
            {`${recipeCount} recipe${recipeCount === 1 ? '' : 's'}`}
          </Text>
        </Box>
      </Box>
      <Box
        data-testid="category-branding-body"
        paddingH={[3, 3, 4]}
        paddingBottom={[3, 4]}
        style={{ backgroundColor: 'transparent' }}
      >
        {children}
      </Box>
    </Box>
  )
}
